export default (s,b,i,c)=> {
  if(s != undefined && s != "") {
    for(b=i=0;c=s.charCodeAt(i++);b+=c>>11?3:c>>7?2:1);
    return b;
  } else {
    return 0;
  }
}